import React, { useEffect, useRef, useState, useCallback } from "react";

import ShopLocatorInfo from "./shopLocatorInfo";
import ShopLocatorSwiper from "./shopLocatorSwiper";
import { useSelector } from "react-redux";

const StoreLocator = ({ cmpnyIntroduce }) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const swiperRef = useRef();

  const locator = { title: "상점", info: "물품을 파는 근처 상점을 알려드릴게요", type: "store" };

  const clickEvent = (item) => {
    window.open(`https://1472.ai/shop/${item.domain}`);
  };

  return (
    <div className="inner">
      <ShopLocatorInfo locator={locator} />
      <ShopLocatorSwiper
        type={locator.type}
        swiperRef={swiperRef}
        data={cmpnyIntroduce}
        clickEvent={clickEvent}
      />
    </div>
  );
};

export default StoreLocator;
